/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Section_Timing_SyncInputs */

const en_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing & Sync`)
};

const fr_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutage et synchronisation`)
};

const de_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing & Synchronisation`)
};

const it_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempistica e sincronizzazione`)
};

const ru_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация и определение времени`)
};

const es_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización y tiempo`)
};

const zh_cn2_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时序与同步`)
};

const ja_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングと同期`)
};

const hi_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय और सिंक्रनाइज़ेशन`)
};

const pt_pt2_options_editor_section_timing_sync = /** @type {(inputs: Options_Editor_Section_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização e ajuste de tempo`)
};

/**
* | output |
* | --- |
* | "Timing & Sync" |
*
* @param {Options_Editor_Section_Timing_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_section_timing_sync = /** @type {((inputs?: Options_Editor_Section_Timing_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Section_Timing_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_section_timing_sync(inputs)
	if (locale === "de") return de_options_editor_section_timing_sync(inputs)
	if (locale === "it") return it_options_editor_section_timing_sync(inputs)
	if (locale === "ru") return ru_options_editor_section_timing_sync(inputs)
	if (locale === "es") return es_options_editor_section_timing_sync(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_section_timing_sync(inputs)
	if (locale === "ja") return ja_options_editor_section_timing_sync(inputs)
	if (locale === "hi") return hi_options_editor_section_timing_sync(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_section_timing_sync(inputs)
	return en_options_editor_section_timing_sync(inputs)
});